// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"app-components-profile-deleteaccountform--wrapper","button":"app-components-profile-deleteaccountform--button"};